import { error, finish } from '../../../../modules/ladders/actions/masterLadder/get';
import api from '../../../../api';

export function request(dispatch) {
    // api.get(`/ladders/masterladder`,  void 0, { cache: true }).then(
    //     ladder => dispatch(finish(ladder)),
    //     ({ errors }) => dispatch(error(errors))
    // );

    $appState.sdkStaff.getPriceMasterLadder()
        .then(data => dispatch(finish(data)))
        .catch(errors => dispatch(error(errors)));
}
